import * as React from "react"
import "../styles.css"
import * as styles from "./layout.css"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
import { TColor } from "../types"
import { Slice } from "gatsby"
import { colorArrayToString } from "../utils"

interface LayoutProps {
  children?: React.ReactNode
  empty?: boolean
  background?: {
    image: {
      id: string
      title: string
      localFile?: {
        childImageSharp?: {
          gatsbyImageData?: any
        }

      }
      gatsbyImageData?: any,
    },
    overlayColor?: string | TColor
    overlayOpacity?: string,
  }
  location?: string
}

const Body = ({ children, empty = false, location }) => {
  return !empty ? (
    <>
      <Slice alias="header" location={location}/>
        {children}
      <Slice alias="footer" />
    </>
  ) : children
}

const Layout: React.FC<LayoutProps> = ({ background, empty, children, location }) => {
  const defaultBackgroundQuery = useStaticQuery(
    graphql`
      query {
        background: file(relativePath: { eq: "_background.jpg" }) {
          childImageSharp {
            gatsbyImageData(
              width: 2000
              placeholder: BLURRED
              formats: [AUTO]
            )
          }
        }
      }
    `
  )
  const defaultBackground = defaultBackgroundQuery.background
  
  const backgroundImage = background?.image?.localFile?.childImageSharp ? background?.image?.localFile?.childImageSharp?.gatsbyImageData: defaultBackground
  const overlayColor = background?.overlayColor ? 
    (typeof background?.overlayColor === "string") ? background?.overlayColor : colorArrayToString(background.overlayColor) : null

  return (
    <div className={styles.pageBody}>
      <GatsbyImage
        className={styles.backgroundImage}
        alt="Background Image"
        image={getImage(backgroundImage)}
      />
      {background?.overlayColor && (
        <div className={styles.backgroundOverlay} style={{ backgroundColor: overlayColor, opacity: background.overlayOpacity }} />
      )}
      <div className={styles.contentContainer}>
        <Body empty={empty} location={location}>
          {children}
        </Body>
      </div>
    </div>
  )
}

export default Layout
